import { lazy } from 'react';
import { createRouteItem } from 'utils/navigation';
import type { RouterType } from 'commons/modules/routers/routes';
import { MENU_KEYS, SCREENS_KEYS } from 'constants/constants';

const OnboardingView = lazy(
  () => import('views/NewClient/Onboarding/PhysicalPerson'),
);

const routers: RouterType[] = [
  {
    exact: true,
    path: '/clientes/nuevo',
    component: OnboardingView,
    fallback: '/clientes/nuevo',
    menuKey: MENU_KEYS.clients,
    screenKey: SCREENS_KEYS.onboarding,
    breadcrumbs: {
      title: 'Nuevo Cliente',
      routes: [
        createRouteItem('Home', '/'),
        createRouteItem('Crear cliente', '/clientes/nuevo'),
      ],
    },
  },
  {
    exact: true,
    path: '/clientes/fisica/:clientId',
    component: OnboardingView,
    fallback: '/clientes/fisica/:clientId',
    menuKey: MENU_KEYS.clients,
    screenKey: SCREENS_KEYS.onboarding,
    breadcrumbs: {
      title: ' Cliente',
      routes: [
        createRouteItem('Home', '/'),
        createRouteItem('Editar cliente', '/clientes/fisica/:clientId'),
      ],
    },
  },
];

export default routers;
